module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/search/search/search.component.css
// module id = ./src/app/search/search/search.component.css
// module chunks = main